(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sistema', {
            parent: 'entity',
            url: '/sistema',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.sistema.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sistema/sistemas.html',
                    controller: 'SistemaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sistema');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sistema-detail', {
            parent: 'entity',
            url: '/sistema/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.sistema.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sistema/sistema-detail.html',
                    controller: 'SistemaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sistema');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Sistema', function($stateParams, Sistema) {
                    return Sistema.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sistema',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sistema-detail.edit', {
            parent: 'sistema-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sistema/sistema-dialog.html',
                    controller: 'SistemaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sistema', function(Sistema) {
                            return Sistema.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sistema.new', {
            parent: 'sistema',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sistema/sistema-dialog.html',
                    controller: 'SistemaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sistema', null, { reload: 'sistema' });
                }, function() {
                    $state.go('sistema');
                });
            }]
        })
        .state('sistema.edit', {
            parent: 'sistema',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sistema/sistema-dialog.html',
                    controller: 'SistemaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sistema', function(Sistema) {
                            return Sistema.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sistema', null, { reload: 'sistema' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sistema.delete', {
            parent: 'sistema',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sistema/sistema-delete-dialog.html',
                    controller: 'SistemaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sistema', function(Sistema) {
                            return Sistema.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sistema', null, { reload: 'sistema' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
